/**
 * Global Users Database References
 *
 * Global users are stored at the root level (/users/{userId})
 * and contain minimal data: client_key, uid, email
 *
 * This enables:
 * - Multi-tenant support
 * - Fast client_key lookup
 * - Clean separation from full user profiles
 */

import {
  doc,
  collection,
  query,
  where,
  orderBy,
  limit,
  DocumentReference,
  CollectionReference,
  Query,
  DocumentData
} from 'firebase/firestore';
import { db } from '../../firebase';

/**
 * Reference to the global users collection
 * Path: /users
 */
export const GlobalUsersRef_Collection = (): CollectionReference<DocumentData> => {
  return collection(db, 'users');
};

/**
 * Reference to a specific global user document
 * Path: /users/{userId}
 */
export const GlobalUserRef_Document = (userId: string): DocumentReference<DocumentData> => {
  return doc(db, 'users', userId);
};

/**
 * Query for global users by client_key
 * Useful for admin operations
 */
export const GlobalUsersByClientRef_Query = (
  clientKey: string,
  limitCount?: number
): Query<DocumentData> => {
  const baseQuery = query(
    GlobalUsersRef_Collection(),
    where('client_key', '==', clientKey),
    orderBy('created_at', 'desc')
  );

  if (limitCount) {
    return query(baseQuery, limit(limitCount));
  }

  return baseQuery;
};
